<template>
  <div class="organization container-fluid">
    <div class="row header-row">
      <div class="col-12 col-md-4 col-lg-6">
        <h1>Reporting</h1>
      </div>
      <div
        v-if="organizations"
        class=" col-12 col-md-8 col-lg-6 align-fix"
      >
        <select
          v-if="$store.getters.isKgbAdminUser"
          v-model="selectedOrg"
          class="upper-select custom-select"
        >
          <option
            v-for="org in organizationSelectOptions"
            :key="org.id"
            :value="org.id"
          >
            {{ org.name }}
          </option>
        </select>

        <button
          v-if="$store.getters.isAdminUser"
          class="btn btn--primary"
          type="button"
          @click="showCreateModal()"
        >
          <font-awesome-icon
            :icon="['fas', 'plus']"
            class="icon alt"
          />
          New Report
        </button>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!reporting"
        class="col-12"
      >
        <Loader />
      </div>
      <div
        v-else-if="filteredReports.length === 0"
        class="col-12"
      >
        <div class="no-results text-center">
          <div class="vertical-center">
            No Results Found
          </div>
        </div>
      </div>
      <div
        v-else
        class="col-12"
      >
        <div>
          <responsive-table>
            <reporting-table
              :report-data="filteredReports"
              :show-edit-modal="showEditModal"
              :remove-report="removeReport"
            />
          </responsive-table>
        </div>
      </div>
    </div>
    <configure-reports-modal
      ref="configureModal"
      :do-cancel="cancelModal"
      :do-save="saveReportConfiguration"
      :report-data="3"
      :user-client="userClient"
    />
  </div>
</template>

<script>
import ResponsiveTable from '@/components/ResponsiveTable.vue';
import ReportingTable from '@/components/tables/ReportingTable.vue';
import Loader from '@/components/Loader.vue';
import ConfigureReportsModal from '@/components/modals/ConfigureReportsModal.vue';

import UserClient from '@/api/UserClient';

export default {
  name: 'Reporting',
  components: {
    ResponsiveTable,
    ReportingTable,
    Loader,
    ConfigureReportsModal,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      reporting: [],
      organizations: [],
      selectedOrg: 'all',
    };
  },
  computed: {
    organizationSelectOptions() {
      const options = [{ id: 'all', name: 'All Organizations' }];
      if (!this.organizations) {
        return options;
      }
      return [...options, ...this.organizations.filter(x => !x.is_removed).map(org => ({
        id: `${org.id}`,
        name: org.name,
      }))];
    },
    filteredReports() {
      if (this.reporting) {
        return this.reporting.filter(x => this.selectedOrg === 'all' || `${x.organization_id}` === this.selectedOrg);
      }
      return [];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params': function () {
      const newSelectedOrg = this.$route.query.org ? this.$route.query.org : 'all';
      if (newSelectedOrg !== this.selectedOrg) {
        this.selectedOrg = newSelectedOrg;
      }
    },
    selectedOrg(value) {
      if (value !== 'all') {
        this.$router.push({ query: { ...this.$route.query, org: value, p: 1 } });
      } else {
        this.$router.push({ query: { ...this.$route.query, org: undefined, p: 1 } });
      }
    },
  },
  mounted() {
    this.selectedOrg = this.$route.query.org ? this.$route.query.org : 'all';
    this.getReporting();
    if (this.$store.getters.isKgbAdminUser) {
      this.userClient.getOrganizations().then((orgs) => {
        orgs.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        this.organizations = orgs;
      }).catch(() => {
        this.organizations = [];
      });
    }
  },
  methods: {
    getReporting() {
      this.reporting = null;
      this.userClient.getReporting().then((reporting) => {
        this.reporting = reporting.map(x => ({ ...x, reportStatus: x.enabled ? 'Enabled' : 'Disabled' }));
      }).catch(() => {
        this.reporting = [];
      });
    },
    showEditModal(reportModel) {
      this.$refs.configureModal.$children[0].show();
      this.$refs.configureModal.setModal(reportModel, this.organizations);
    },
    removeReport(reportModel) {
      this.reporting = this.reporting.filter(x => x.id !== reportModel.id);
      this.userClient.removeReport(reportModel.id);
    },
    showCreateModal() {
      this.$refs.configureModal.$children[0].show();
      this.$refs.configureModal.setModal({}, this.organizations);
    },
    cancelModal() {
      this.$refs.configureModal.$children[0].hide();
    },
    saveReportConfiguration(id, data, whenDone) {
      if (id) {
        this.userClient.updateReport(id, data).then(() => {
          this.cancelModal();
          this.getReporting();

          this.$store.commit('setGlobalAlert', {
            msg: 'Report configuration saved!',
          });
        }).catch(() => {
          this.$store.commit('setGlobalAlert', {
            msg: 'Unable to save report configuration. Please try again!', error: true,
          });
          whenDone();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
